var map = {
	"./template.bet575": 1479,
	"./template.bet575.tsx": 1479,
	"./template.bet777": 1480,
	"./template.bet777.tsx": 1480,
	"./template.betgalaxy": 1481,
	"./template.betgalaxy.tsx": 1481,
	"./template.betprofessor": 1482,
	"./template.betprofessor.tsx": 1482,
	"./template.betroyale": 1483,
	"./template.betroyale.tsx": 1483,
	"./template.betstride": 1484,
	"./template.betstride.tsx": 1484,
	"./template.buffalobet": 1485,
	"./template.buffalobet.tsx": 1485,
	"./template.chromabet": 1486,
	"./template.chromabet.tsx": 1486,
	"./template.default": 663,
	"./template.default.tsx": 663,
	"./template.epicodds": 1487,
	"./template.epicodds.tsx": 1487,
	"./template.fiestabet": 1488,
	"./template.fiestabet.tsx": 1488,
	"./template.forsport": 1489,
	"./template.forsport.tsx": 1489,
	"./template.gigabet": 1490,
	"./template.gigabet.tsx": 1490,
	"./template.goldenbet888": 1491,
	"./template.goldenbet888.tsx": 1491,
	"./template.goldenrush": 1492,
	"./template.goldenrush.tsx": 1492,
	"./template.hyperbet": 1493,
	"./template.hyperbet.tsx": 1493,
	"./template.juicybet": 1494,
	"./template.juicybet.tsx": 1494,
	"./template.junglebet": 1495,
	"./template.junglebet.tsx": 1495,
	"./template.magnumbet": 1496,
	"./template.magnumbet.tsx": 1496,
	"./template.oldgill": 1497,
	"./template.oldgill.tsx": 1497,
	"./template.puntcity": 1498,
	"./template.puntcity.tsx": 1498,
	"./template.puntgenie": 1499,
	"./template.puntgenie.tsx": 1499,
	"./template.pyramidbet": 1500,
	"./template.pyramidbet.tsx": 1500,
	"./template.questbet": 1501,
	"./template.questbet.tsx": 1501,
	"./template.slambet": 1502,
	"./template.slambet.tsx": 1502,
	"./template.sterlingparker": 1503,
	"./template.sterlingparker.tsx": 1503,
	"./template.sugarcastle": 1504,
	"./template.sugarcastle.tsx": 1504,
	"./template.templebet": 1505,
	"./template.templebet.tsx": 1505,
	"./template.titanbet": 1506,
	"./template.titanbet.tsx": 1506,
	"./template.ts": 976,
	"./template.vikingbet": 1507,
	"./template.vikingbet.tsx": 1507,
	"./template.volcanobet": 1508,
	"./template.volcanobet.tsx": 1508,
	"./template.wellbet": 1509,
	"./template.wellbet.tsx": 1509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2440;